module.exports = __webpack_public_path__ + "img/kf_zl.28502fe5.jpg";